import { Bluex, Tealx, Pinkx, DeepBluex, Nudex, Purplex, Napolix, Celestex, Orangex, Redx, Greenx, Greyx, AlphaDeep } from "../../../foundations/colors.es.js";
import { Primary, Secondary, Tertiary, ErrorToken, Warning, Info, Success, Purple, DeepBlue, Text, Action, Border, Background } from "../../../foundations/palette.es.js";
const colorMapper = {
  Bluex,
  Tealx,
  Pinkx,
  DeepBluex,
  Nudex,
  Purplex,
  Napolix,
  Celestex,
  Orangex,
  Redx,
  Greenx,
  Greyx,
  AlphaDeep
};
const paletteMapper = {
  Primary: {
    ...Primary,
    main: {
      token: "Bluex 400",
      color: Bluex["400"]
    },
    light: {
      token: "Bluex 50",
      color: Bluex["50"]
    },
    dark: {
      token: "Bluex 500",
      color: Bluex["500"]
    }
  },
  Secondary: {
    ...Secondary,
    main: {
      token: "Tealx 400",
      color: Tealx["400"]
    },
    light: {
      token: "Tealx 0",
      color: Tealx["0"]
    },
    dark: {
      token: "Tealx 500",
      color: Tealx["500"]
    }
  },
  Tertiary: {
    ...Tertiary,
    main: {
      token: "Pinkx 400",
      color: Pinkx["400"]
    },
    light: {
      token: "Pinkx 0",
      color: Pinkx["0"]
    },
    dark: {
      token: "Pinkx 500",
      color: Pinkx["500"]
    }
  },
  Error: {
    ...ErrorToken,
    main: {
      token: "Redx 400",
      color: Redx["400"]
    },
    light: {
      token: "Redx 200",
      color: Redx["200"]
    },
    dark: {
      token: "Redx 600",
      color: Redx["600"]
    }
  },
  Warning: {
    ...Warning,
    main: {
      token: "Orangex 400",
      color: Orangex["400"]
    },
    light: {
      token: "Orangex 100",
      color: Orangex["100"]
    },
    dark: {
      token: "Orangex 600",
      color: Orangex["600"]
    }
  },
  Info: {
    ...Info,
    main: {
      token: "Napolix 500",
      color: Napolix["500"]
    },
    light: {
      token: "Napolix 0",
      color: Napolix["0"]
    },
    dark: {
      token: "Napolix 600",
      color: Napolix["600"]
    }
  },
  Success: {
    ...Success,
    main: {
      token: "Greenx 400",
      color: Greenx["400"]
    },
    light: {
      token: "Greenx 0",
      color: Greenx["0"]
    },
    dark: {
      token: "Greenx 500",
      color: Greenx["500"]
    }
  },
  Purple: {
    ...Purple,
    main: {
      token: "Purplex 400",
      color: Purplex[400]
    },
    light: {
      token: "Purplex 100",
      color: Purplex[100]
    },
    dark: {
      token: "Purplex 700",
      color: Purplex[700]
    }
  },
  DeepBlue: {
    ...DeepBlue,
    main: {
      token: "DeepBluex 300",
      color: DeepBluex["300"]
    },
    light: {
      token: "DeepBluex 0",
      color: DeepBluex["0"]
    },
    dark: {
      token: "DeepBluex 700",
      color: DeepBluex["700"]
    }
  },
  Text: {
    ...Text,
    primary: {
      token: "DeepBluex 600",
      color: DeepBluex["600"]
    },
    secondary: {
      token: "AlphaDeep 70",
      color: AlphaDeep["70"]
    },
    disabled: {
      token: "AlphaDeep 38",
      color: AlphaDeep["38"]
    }
  },
  Action: {
    ...Action,
    active: {
      token: "AlphaDeep 56",
      color: AlphaDeep["56"]
    },
    disabled: {
      token: "AlphaDeep 24",
      color: AlphaDeep["24"]
    },
    disabledBackground: {
      token: "AlphaDeep 12",
      color: AlphaDeep["12"]
    },
    focus: {
      token: "AlphaDeep 12",
      color: AlphaDeep["12"]
    },
    hover: {
      token: "AlphaDeep 4",
      color: AlphaDeep["4"]
    },
    selected: {
      token: "AlphaDeep 8",
      color: AlphaDeep["8"]
    }
  },
  Border: {
    ...Border,
    main: {
      token: "AlphaDeep 12",
      color: AlphaDeep["12"]
    },
    light: {
      token: "AlphaDeep 10",
      color: AlphaDeep["10"]
    },
    dark: {
      token: "AlphaDeep 30",
      color: AlphaDeep["30"]
    },
    outlinedBorder: {
      token: "AlphaDeep 50",
      color: AlphaDeep["50"]
    },
    selected: {
      token: "AlphaDeep 8",
      color: AlphaDeep["8"]
    },
    focus: {
      token: "AlphaDeep 12",
      color: AlphaDeep["12"]
    },
    focusVisible: {
      token: "AlphaDeep 30",
      color: AlphaDeep["30"]
    },
    fillBackdrop: {
      token: "AlphaDeep 50",
      color: AlphaDeep["50"]
    }
  },
  Background: {
    ...Background,
    default: {
      token: "Greyx 0",
      color: Greyx["0"]
    }
  }
};
function isColorPaletteWithToken(value) {
  return value.token !== void 0;
}
export {
  colorMapper,
  isColorPaletteWithToken,
  paletteMapper
};
//# sourceMappingURL=utils.es.js.map
